import { Checkbox, FormControlLabel, FormGroup, Button, Grid } from '@material-ui/core';
import React, { useMemo } from 'react';
import ArticleField from '../ArticleField';
import { Notif } from '../../interfaces/article';
import Fetcher from '../../services/fetcher';
import settings from '../../settings';
import { useNotification } from '../../contexts/Notification';

interface NotificationPickerProps {
    value: Notif,
    article: any,
    articleType: string,
    onChange: (new_value: Notif) => void,
}

function notifToBool(notif: Notif): boolean[] {
    return {
        [Notif.NoNotif]: [false, false],
        [Notif.Notif]: [true, false],
        [Notif.NotifNow]: [true, true],
    }[notif];
}

function boolToNotif(notif: boolean, now: boolean): Notif {
    if (notif) {
        if (now) {
            return Notif.NotifNow
        } else {
            return Notif.Notif
        }
    } else {
        return Notif.NoNotif
    }
}


const NotificationPicker = (props: NotificationPickerProps) => {
    const [notif, notifNow] = useMemo(() => notifToBool(props.value), [props.value]);
    const notification = useNotification();

    function sendNotification(){
      const article = props.article;
      return Fetcher.post(settings.notifApi, JSON.stringify({
          article: article.slug,
          caption: article.short_hat,
          title: article.title,
          type: props.articleType,
          now: true,
          url: `${settings.frontUrl}article/${props.articleType}/${article.slug}`,
          publishedDate: new Date().getTime(),
      }))
    }

    return <ArticleField label="Notification mobile">
        <FormGroup>
            <FormControlLabel
                control={<Checkbox checked={notif} onChange={e => {
                    props.onChange(boolToNotif(e.target.checked, notifNow))
                }}/>}
                label="Ajouter à la file d’attente des notifications"
            />
            <Grid item>
              <Button color="primary" variant="contained" onClick={() => {
                sendNotification().then(() => {notification.notify("notification envoyé")}).catch(() => {notification.notify("Erreur", "error")})
              }}> Notifier maintenant </Button>
            </Grid>
        </FormGroup>
    </ArticleField>
}

export default NotificationPicker;